import { useContext, useCallback } from "react";

// Import Context
import { AlertNotificationContext } from "../contexts/AlertNotificationContext";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function AlertSnackbar() {
  const { alertNotification, setAlertNotification } = useContext(
    AlertNotificationContext,
  );

  const handleClose = useCallback(
    (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setAlertNotification({ message: "", severity: "" });
    },
    [setAlertNotification],
  );

  return (
    <Snackbar
      open={alertNotification.message !== ""}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={alertNotification.severity || "info"}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {alertNotification.message}
      </Alert>
    </Snackbar>
  );
}
